import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiService } from '../services/api';
import Loader from '../components/Loader';

export default function BarterDetail() {
  const { id } = useParams<{ id: string }>();
  const [barter, setBarter] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadBarter();
  }, [id]);

  const loadBarter = async () => {
    if (!id) return;
    try {
      const response = await apiService.getBarter(id);
      setBarter(response.data.data);
    } catch (error) {
      console.error('Error loading barter:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader className="py-12" />;
  }

  if (!barter) {
    return (
      <div className="text-center py-8">
        <p className="text-tg-theme-hint">Предложение не найдено</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-bold">🔁 Обмен</h1>
      
      <div className="card">
        <div className="flex items-center gap-2 mb-2">
          <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium">
            Отдам
          </span>
        </div>
        <h3 className="font-semibold mb-2">{barter.offerTitle}</h3>
        <p className="text-sm text-tg-theme-hint">{barter.offerDescription}</p>
      </div>

      <div className="text-3xl text-center">🔄</div>

      <div className="card">
        <div className="flex items-center gap-2 mb-2">
          <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-medium">
            Получу
          </span>
        </div>
        <h3 className="font-semibold mb-2">{barter.wantTitle}</h3>
        <p className="text-sm text-tg-theme-hint">{barter.wantDescription}</p>
      </div>

      <div className="card">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-tg-theme-button flex items-center justify-center text-white text-xl">
            {barter.user.firstName[0]}
          </div>
          <div>
            <p className="font-semibold">{barter.user.firstName}</p>
            <p className="text-sm text-tg-theme-hint">
              ⭐️ {barter.user.rating.toFixed(1)}
            </p>
          </div>
        </div>
      </div>

      <button className="btn-primary w-full">
        🤝 Предложить обмен
      </button>
    </div>
  );
}
